import {createApp} from 'vue'

const app = createApp({
    name: "Cart",
    data() {
        return {
            refreshKey: 0,
        }
    },
    computed: {
        list() {
            let storage = JSON.parse(localStorage.getItem('webien_cart'));
            let arr = [];
            this.refreshKey;

            let str = '';

            if(storage && storage.hasOwnProperty('products')){
                for (const key in storage.products) {
                    arr.push(storage.products[key]);
                    str += storage.products[key].title + ' [SKU: ' + key + '] (' + storage.products[key].count + 'st). ';
                }
            }

            // Update form field (both from div or directly on input)
            if(formFieldProduct){
                let el = document.getElementById(formFieldProduct);
                if(el){
                    el.value = str;
                    let input = el.querySelector('input');
                    if(input){
                        input.value = str;
                    }
                }

            }

            // Check if we should update the minicart
            let event = new Event("cartUpdated", {'detail': {'fromCheckout': true}});
            window.dispatchEvent(event);

            return arr;
        }
    },
    watch: {},
    methods: {
        removeProduct(item){
            let  storage = JSON.parse(localStorage.getItem('webien_cart'));
            delete storage.products[item];

            /*
            // Check for child products (licenses) and remove them as well.
            for (const key in storage.products) {
                if(storage.products[key].parent === item){
                    delete storage.products[key];
                }
            }

             */

            localStorage.setItem('webien_cart', JSON.stringify(storage));
            this.refreshKey++;
        },
        updateProduct(sku, amount){
            let  storage = JSON.parse(localStorage.getItem('webien_cart'));
            storage.products[sku].count += amount;

            if(storage.products[sku].count < 1 ) return;

            localStorage.setItem('webien_cart', JSON.stringify(storage));
            this.refreshKey++;
        },
        removeBtnText(item){
            /*
            if(item.required) {
                return 'Required';
            }

             */
            return 'Remove';
        }
    },
    mounted: function () {

    },
    created() {

    },
    components: {}
});

// Mount app to DOM
const appCart = document.getElementById('appCart');
if (appCart) {
    window.appCart = app.mount('#appCart');
}




